import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AdminDeliveryWindowsPage } from '@features/admin/delivery-windows';
import { useAdminDeliveryWindowStore } from '@features/admin/delivery-windows';

const adminDeliveryWindowsSearchSchema = z.object({
  organizationId: z.coerce.number().optional(),
  portalId: z.coerce.number().optional(),
  supplierId: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminDeliveryWindowsSearch = z.infer<typeof adminDeliveryWindowsSearchSchema>;

export const Route = createFileRoute('/admin/delivery-windows/')({
  validateSearch: search => adminDeliveryWindowsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { organizationId, portalId, supplierId, page, size } = ctx.search;
    // Seznam stojí na zákazníkovi nebo na dodavateli — bez aspoň jednoho z nich není co načítat.
    if (organizationId || supplierId) {
      useAdminDeliveryWindowStore.getState().loadDeliveryWindows({ organizationId, portalId, supplierId, page: page || 1, size: size || 20 });
    }
  },
});

function RouteComponent() {
  return <AdminDeliveryWindowsPage />;
}
